import { useUser } from './useUser';

export const useValidUserForReAuth = () => {
  const { email, loginUserName } = useUser();
  const isValidUserForReAuth = (userName: string) => {
    if (userName === email || userName === loginUserName) {
      return true;
    }
    return false;
  };
  return { isValidUserForReAuth };
};
